import React, { useEffect, useState } from "react";
import styles from "./NumberScoreComponent.module.scss";
import { Tooltip } from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SingleRangeComponent from "components/singlerange/SingleRangeComponent";
import { truncateText } from "utils/utils";
import { setPublish } from "@redux/slices/globalSlice";
import { useDispatch } from "react-redux";
const NumberScoreComponent = ({ handleDelete, item }) => {
  // console.log(item);
  const [show, setShow] = useState(false);
const dispatch = useDispatch();

  const handleCheck = (e) => {
    dispatch(setPublish(true));
    setShow(e?.target?.checked);
  };

  useEffect(() => {
    if (item?.scoreType==="byRange") {
      setShow(!show);
    }
  }, [item]);

  return (
    <>
      <div className={styles?.scoreContainer}>
        <div className={styles?.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip title={item?.name}>
              <span>{truncateText(item?.name || "", 50)}</span>
            </Tooltip>
            <Tooltip title={"Formula will use inputted value"}>
              <InfoOutlinedIcon
                fontSize="small"
                sx={{ color: "#3e9ef7", cursor: "pointer" }}
              />
            </Tooltip>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span>
              <input
                type="checkbox"
                onChange={(e) => handleCheck(e)}
                checked={show}
              />{" "}
              Score by Range
            </span>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(item.id, item?.fieldId)}
            >
              <HighlightOffOutlinedIcon
                sx={{ color: "#3e9ef7" }}
                fontSize="medium"
              />
            </span>
          </div>
        </div>
        {show && (
          <div className={styles?.options}>
            <div>
              <SingleRangeComponent item={item} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NumberScoreComponent;
